export default __webpack_public_path__ + "static/registration_background-d9abcd276647f95473576bee3e5be048.png";